import {radish0,peas0,celery0,beet0,cabbage0,potato0,pear0,strawberry0,pineapple0,kiwi0,raspberry0,vritra0} from "Assets";


export {default as FruitList} from "./ProduceList/FruitList";
export {default as ProduceListWithArrayMapJS} from "./ProduceList/ProduceListWithArrayMap";
export {default as ProduceList} from "./ProduceList/ProduceList";
export {default as ProduceMarket} from "./ProduceMarket/ProduceMarket";
export {default as ProduceAisle} from "./ProduceAisle/ProduceAisle";
export {default as ProduceBasket} from "./ProduceBasket/ProduceBasket";
export {default as ProduceView} from "./ProduceView/ProduceView";

export const produce={
    fruits:[
        {name:"vritra",image:vritra0,price:15},
        {name:"pear",image:pear0,price:19},
        {name:"pineapple",image:pineapple0,price:12},
        {name:"strawberry",image:strawberry0,price:14},
        {name:"kiwi",image:kiwi0,price:20},
        {name:"raspberry",image:raspberry0,price:13},
    ],
    vegetables:[
        {name:"potato",image:potato0,price:11},
        {name:"cabbage",image:cabbage0,price:18},
        {name:"beet",image:beet0,price:21},
        {name:"celery",image:celery0,price:17},
        {name:"peas",image:peas0,price:16},
        {name:"radish",image:radish0,price:10},
    ],
}
